export class Sheet {
    id: number;
    name: string;
    minutes: number;
    formula: string;
}
